import { render, staticRenderFns } from "./ModalStudentTimetablePrivate.vue?vue&type=template&id=b842a276&scoped=true&lang=pug&"
import script from "./ModalStudentTimetablePrivate.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentTimetablePrivate.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentTimetablePrivate.vue?vue&type=style&index=0&id=b842a276&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b842a276",
  null
  
)

export default component.exports